<template>

    <div class="j-rows-per-page-wrapper">
        <div class="flex items-center space-x-2">
            <div class="j-label">Page Items:</div>
            <div class="">
                <select class="cm-select-input min-w-20" :value="modelValue" @change="change">
                    <option :value="10">10</option>
                    <option :value="20">20</option>
                    <option :value="50">50</option>
                    <option :value="100">100</option>
                </select>
            </div>
        </div>
    </div>

</template>

<script setup>
const emit                  = defineEmits([
    'change',
    'update:modelValue',
])

const props                 = defineProps({
    modelValue : Number,
})

const change    = ($event) => {
    emit("update:modelValue", Number($event.target.value))

    emit('change')
}

</script>
